import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import "react-image-crop/dist/ReactCrop.css";
import { Button } from "react-bootstrap";
import { Modal } from "@material-ui/core";
import IDFUpload from "./IDFUpload";
import IDFSync from "./IDFSync";
import IDFReport from "./IDFReport";

const AdminIdfModal = ({ handleIdfUpload, idfModal, getallmeetings }) => {
  const [key, setKey] = useState("upload");
  const [tabDisable, setTabDisable] = useState(false);

  return (
    <div>
      <Modal
        open={idfModal}
        onClose={handleIdfUpload}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalContent"
      >
        <MDBCard className="modal_card collective_content">
          <MDBCardBody className="admin-idf">
            <div className="toggleDiv">
              <div className="tab-grid">
                <Button
                  onClick={() => {
                    setKey("upload");
                  }}
                  className={key == "upload" ? "spanActive" : "toggle "}
                  disabled={tabDisable}
                >
                  File Upload
                </Button>
                <Button
                  onClick={() => {
                    setKey("report");
                  }}
                  className={key == "report" ? "spanActive" : "toggle "}
                  disabled={tabDisable}
                >
                  Reports
                </Button>
                <Button
                  onClick={() => {
                    setKey("sync");
                  }}
                  className={key == "sync" ? "spanActive" : "toggle "}
                  disabled={tabDisable}
                >
                  Sync
                </Button>
              </div>
            </div>
            {key === "upload" && <IDFUpload handleIdfUpload={handleIdfUpload} idfModal={idfModal} getallmeetings={getallmeetings} setTabDisable={setTabDisable} />}
            {key === "report" && <IDFReport handleIdfUpload={handleIdfUpload} setTabDisable={setTabDisable} />}
            {key === "sync" && <IDFSync handleIdfUpload={handleIdfUpload} setTabDisable={setTabDisable} />}
          </MDBCardBody>
        </MDBCard>
      </Modal>
    </div>
  );
};
export default AdminIdfModal;
